import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getConsent, setConsent, trackEvent } from "../../lib/analytics";

// Page views are sent by GA4 enhanced measurement (history changes); here: consent banner + lead events
export const Analytics = () => {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!getConsent()) setShow(true);
    const onClick = (e) => {
      const a = e.target.closest?.("a[href^='tel:'], a[href^='mailto:']");
      if (a) trackEvent(a.href.startsWith("tel:") ? "click_to_call" : "click_email", { page_path: window.location.pathname });
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  if (!show || pathname.startsWith("/admin")) return null;
  const choose = (v) => { setConsent(v); setShow(false); };
  return (
    <div className="fixed z-[55] left-3 right-3 bottom-24 lg:bottom-6 lg:left-6 lg:right-auto lg:max-w-md rounded-3xl bg-forest text-cream p-5 shadow-2xl shadow-forest/40" role="dialog" aria-label="Cookies" data-testid="cookie-banner">
      <p className="flex items-center gap-2 font-display font-bold text-lg"><Cookie className="w-5 h-5 text-lime" />Cookies de mesure d'audience</p>
      <p className="mt-2 text-sm text-cream/85">Avec votre accord, nous utilisons Google Analytics pour mesurer la fréquentation du site et l'améliorer. Aucune publicité. <Link to="/politique-de-confidentialite" className="underline">En savoir plus</Link></p>
      <div className="mt-4 flex gap-2">
        <button onClick={() => choose("granted")} className="btn btn-lime !py-2.5 flex-1" data-testid="cookie-accept">Accepter</button>
        <button onClick={() => choose("denied")} className="btn btn-ghost-light !py-2.5 flex-1" data-testid="cookie-refuse">Refuser</button>
      </div>
    </div>
  );
};
